"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const setColor = (variant, colors) => {
    switch (variant) {
        case "blue":
            return colors.blueBase;
        case "pink":
            return colors.pinkBase;
        case "green":
            return colors.greenBase;
    }
};
const setBackgroundColor = (variant, colors) => {
    switch (variant) {
        case "blue":
            return colors.blueLighten80;
        case "pink":
            return colors.pinkLighten80;
        case "green":
            return colors.greenLighten80;
    }
};
const Notification = ({ content, 
/** @deprecated */
isSuccess, variant }) => {
    const notificationVariant = variant || (isSuccess ? "blue" : "pink");
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { "data-component": "notification", "data-cy": `notification-${notificationVariant}`, variant: notificationVariant, children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: notificationVariant !== "pink" ? "circle" : "rectangle", icon: notificationVariant !== "pink"
                    ? ["fas", "check-circle"]
                    : ["fas", "exclamation-triangle"], size: "lg" }, void 0), (0, jsx_runtime_1.jsx)("div", { children: typeof content === "string" ? (0, jsx_runtime_1.jsx)(typography_1.P, { children: content }, void 0) : content }, void 0)] }, void 0));
};
exports.Notification = Notification;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ variant, theme }) => setBackgroundColor(variant, theme.colors)};
  align-items: center;
  display: flex;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  & > div:last-of-type {
    color: ${({ variant, theme }) => setColor(variant, theme.colors)};
    flex: 1;
    margin-left: ${({ theme }) => theme.spacings.m};

    & > * {
      display: inline-block;
      font-size: 1rem;
      letter-spacing: -0.01rem;
      line-height: 1.5;
      line-height: normal;
    }
  }

  p {
    color: inherit;
    margin-bottom: 0;
  }

  & svg {
    color: ${({ variant, theme }) => setColor(variant, theme.colors)};
  }

  a {
    color: inherit;
    cursor: pointer;
  }
`;
//# sourceMappingURL=index.js.map